import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "rask-feature-inactivated",
    templateUrl: "./feature-inactivated.component.html",
    styleUrls: ["./feature-inactivated.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class FeatureInactivatedComponent {

}
